import { Auth0Client } from '@auth0/auth0-spa-js';
import { AUTH_CONFIG } from './auth0-variables';

let _client = null;

export const getAuth0Client = () => {
    if (!_client) {
        _client = new Auth0Client({
            domain: AUTH_CONFIG.domain,
            clientId: AUTH_CONFIG.clientId,
            authorizationParams: {
                redirect_uri: AUTH_CONFIG.callbackUrl,
                audience: AUTH_CONFIG.audience,
                // offline_access makes Auth0 issue a refresh token so getTokenSilently uses the
                // fast refresh-token grant instead of the slow/cookie-blocked hidden-iframe flow.
                scope: 'openid email profile offline_access',
            },
            useRefreshTokens: true,
            useRefreshTokensFallback: true,
            cacheLocation: 'localstorage',
        });
    }
    return _client;
};
